import PropTypes from 'prop-types';
import React from 'react';

function HRWithText({ children }) {
  const color = '#c0c0c0';

  return (
    <div className="formish flex flexAlignCenter noPaddingBottom">
      <hr style={{ flex: 1, border: 'none', borderBottom: `1px solid ${color}` }} />
      <span style={{ margin: '0 16px', color }}>{children}</span>
      <hr style={{ flex: 1, border: 'none', borderBottom: `1px solid ${color}` }} />
    </div>
  );
}

HRWithText.propTypes = {
  children: PropTypes.node.isRequired, // The text to display in the center of the horizontal rule
};

export default HRWithText;
